import * as React from "react"
import {
  BarChart3,
  ClipboardList,
  History,
  Home,
  KeyRound,
  Palette,
  PlugZap,
  Send,
  Users,
  Zap,
} from "lucide-react"
import { MainNav, type NavItemDef } from "@/components/MainNav"

const ADMIN_NAV_ITEMS: NavItemDef[] = [
  {
    href: "/",
    icon: Home,
    label: "App Home",
    match: () => false,
  },
  {
    href: "/admin/users",
    icon: Users,
    label: "Users",
    match: (url) => url.startsWith("/admin/users"),
  },
  {
    href: "/admin/access_groups",
    icon: KeyRound,
    label: "Groups",
    match: (url) => url.startsWith("/admin/access_groups"),
  },
  {
    href: "/admin/automations",
    icon: Zap,
    label: "Automations",
    match: (url) => url.startsWith("/admin/automations"),
  },
  {
    href: "/admin/automation_report",
    icon: BarChart3,
    label: "Automation Report",
    match: (url) => url.startsWith("/admin/automation_report"),
  },
  {
    href: "/admin/weekly_reports",
    icon: ClipboardList,
    label: "Weekly Reports",
    match: (url) => url.startsWith("/admin/weekly_reports"),
  },
  {
    href: "/admin/delivery_settings",
    icon: Send,
    label: "Delivery",
    match: (url) => url.startsWith("/admin/delivery_settings"),
  },
  {
    href: "/admin/change_log",
    icon: History,
    label: "Change Log",
    match: (url) => url.startsWith("/admin/change_log"),
  },
  {
    href: "/admin/connections",
    icon: PlugZap,
    label: "Connections",
    match: (url) => url.startsWith("/admin/connections"),
  },
  {
    href: "/admin/design-system",
    icon: Palette,
    label: "Design System",
    match: (url) => url.startsWith("/admin/design-system"),
  },
]

export function AdminShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen bg-page text-ink-body">
      <MainNav items={ADMIN_NAV_ITEMS} brandHref="/admin/users" />
      <main className="min-w-0 flex-1 px-6 py-8 sm:px-10">
        <div className="mx-auto max-w-4xl xl:max-w-6xl 2xl:max-w-7xl">{children}</div>
      </main>
    </div>
  )
}
